var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showCheckBox)?_c('v-checkbox',{staticClass:"mt-0",attrs:{"hide-details":""},on:{"change":_vm.change},model:{value:(_vm.item.checked),callback:function ($$v) {_vm.$set(_vm.item, "checked", $$v)},expression:"item.checked"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }